/**
 * Created by falknisius on 15.05.17.
 */
// ADD AND CHANGE STRINGS HERE
// ------------------------------------------------------------------------------------------------------------------

const STRINGS = {
  BUTTON_SEND_MESSAGE: {
    de: 'Nachricht absenden',
    en: 'send feedback'
  },

  BUTTON_SEND_NEXT: {
    de: 'Weitere Nachricht senden',
    en: 'send other feedback'
  },

  BUTTON_SEND_REPEAT: {
    de: 'Nachricht nocheinmal senden',
    en: 'try repeat send feedback'
  },

  ERROR_HEADLINE: {
    de: 'Fehler',
    en: 'Error'
  },

  INIT_HEADLINE: {
    de: '... initialisieren ...',
    en: '... inititialize ...'
  },

  TRAINER_HEADLINE: {
    de: 'Dashboard',
    en: 'Dashboard'
  },

  RESET_PASSWORD_HEADLINE: {
    de: 'Passwort zurücksetzen',
    en: 'Reset password'
  },

  SUBJECT_LABEL: {
    de: 'Betreff',
    en: 'Subject'
  },

  MESSAGE_CONTENT: {
    de: 'Nachricht',
    en: 'Message'
  },

  SEND_ERROR: {
    de: 'Fehler beim Senden des Feedbacks: $0',
    en: 'Error on sending Feedback: $0'
  },

  SEND_SUCCESS: {
    de: 'Das Feedback wurde erfolgreich versendet. Vielen Dank.',
    en: 'Thank Your for successfull sending Feedback.'
  },

  SEND_MASSMESSAGE_HEADLINE: {
    de: 'Nachricht an alle Spieler versenden',
    en: 'Send a message to all players'
  },

  FEEDBACK_COPY: {
    de: 'Lieber User, Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
    en: 'Dear User, Lorem Ipsum'
  },

  MESSAGE_ERROR_MESSAGE: {
    de: 'Bitte geben Sie eine Nachricht ein.',
    en: 'Please enter a message.'
  },

  RESET_INFO: {
    de: 'Das Passwort für den User $0 wurde zurückgesetzt. Der User wurde benachrichtigt.',
    en: 'The password for the user $0 was reset. The user was notified.'
  },

  DELETE_INFO: {
    de: 'Der Request für den User $0 wurde gelöscht.',
    en: 'The request for the user $0 was deleted.'
  },

  ERROR_HTTP_COMMUNICATION: {
    de: 'Netzwerk Kommunikation nicht efolgreich',
    en: 'communication error'
  },

  ERROR_WRONG_REQUEST: {
    de: 'Anwendungsprotokoll nicht korrekt umgesetzt',
    en: 'application protocoll mismatch'
  }

}

// THIS IS SOURCE CODE BELOW THIS LINE
// ------------------------------------------------------------------------------------------------------------------

const applyArgsToString = (string, args) => {
  let stringWithAppliedArgs = string
  let i = 0
  args.forEach(arg => {
    stringWithAppliedArgs = stringWithAppliedArgs.replace(`$${i}`, arg)
    i += 1
  })
  return stringWithAppliedArgs
}

export let target = {
  supportedLanguages: ['de', 'en'],
  choosenLanguage: 'de'
}

/**
 * Returns the string for the requested key in the prefererred language.
 * If it is not found all languages of higher priority are checked (as specified in config or target config).
 * If not present there either the key itself will be returned
 *
 * If no preferred language is given, the first language as specified in config or target config is used.
 */
export default (key, args = [], preferredLanguage = target.choosenLanguage) => {
  // return 'key' if key does not exist
  if (!STRINGS[key]) {
    if (!args || args.length > 0) {
      return `${key} (${JSON.stringify(args)}`
    }
    return key
  }

  const strings = STRINGS[key] ? STRINGS[key] : {}

  // check if string exists in preferred language
  if (strings[preferredLanguage]) {
    return applyArgsToString(strings[preferredLanguage], args)
  }

  // find best language
  const bestAvailLanguage = target.supportedLanguages.filter(language => Object.keys(strings).indexOf(language) >= 0)
  return applyArgsToString(strings[bestAvailLanguage], args)
}
